
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"Icon_Login","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{attrs:{"id":"Masked_Area","fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"id":"Icon_Login-2","clip-path":"url(#clip-path)","transform":"translate(2081 1782)"}},[_c('g',{attrs:{"id":"noun_log_in_2149500","transform":"translate(-2077.918 -1779.462)"}},[_c('path',{staticClass:"cls-4",attrs:{"id":"Path_220","d":"M49.9 57.924h-7.4a2.484 2.484 0 01-2.5-2.468v-1.827a.741.741 0 111.483 0v1.827a1 1 0 001.016.985h7.4a.988.988 0 001-.985V41.468a.988.988 0 00-1-.985H42.5a1 1 0 00-1.016.985v2.124a.741.741 0 01-1.483 0v-2.124A2.486 2.486 0 0142.5 39h7.4a2.472 2.472 0 012.485 2.468v13.993a2.471 2.471 0 01-2.485 2.463z","transform":"translate(-33.547 -39)"}}),_c('path',{staticClass:"cls-4",attrs:{"id":"Path_221","d":"M117.079 164.179a.739.739 0 11.994-1.094l3.833 3.462a.74.74 0 010 1.1l-3.833 3.462a.749.749 0 01-.5.192.739.739 0 01-.549-.244.75.75 0 01.052-1.055l2.4-2.18h-12.535a.741.741 0 110-1.483h12.541z","transform":"translate(-107.2 -157.49)"}})])])])
          )
        }
      }
    